import distributorService from 'src/services/distributorService';

export const DISTRIBUTORS_REQUEST = '@distributor/distributors-request';
export const DISTRIBUTORS_SUCCESS = '@distributor/distributors-success';
export const DISTRIBUTORS_FAILURE = '@distributor/distributors-failure';
export const SWITCH_DISTRIBUTOR = '@distributor/switch-distributor';

export function getPermittedDistributors() {
  return async (dispatch) => {
    try {
      dispatch({ type: DISTRIBUTORS_REQUEST });

      const distributors = await distributorService.getPermittedDistributors();

      if (distributors?.distributors?.length > 0) {
        dispatch({
          type: DISTRIBUTORS_SUCCESS,
          payload: {
            distributors: distributors.distributors
          }
        });
      } else {
        throw new Error('No distributors found');
      }
    } catch (error) {
      dispatch({ type: DISTRIBUTORS_FAILURE });
      throw error;
    }
  };
}

export function setActiveDistributor(distributor) {
  return async (dispatch) =>
    dispatch({
      type: SWITCH_DISTRIBUTOR,
      payload: {
        distributor
      }
    });
}
